import React from 'react';
import { motion } from 'framer-motion';
import { heroImage } from '../data/products';
export function Hero() {
  return <section id="top" className="relative w-full bg-bone" data-id="element-138" data-mp="ej4lxsz4c3dc">
      <div className="relative h-[86vh] min-h-[520px] w-full overflow-hidden" data-id="element-139" data-mp="9kjwmolen43o">
        <motion.img src={heroImage} alt="Model wearing a teal modal knit night set in a sunlit empty room" className="h-full w-full object-cover" initial={{
        scale: 1.06,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 1.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-140" data-mp="9igwvcug9wlr" />
        <div className="absolute inset-0 flex items-end" data-id="element-141" data-mp="sa9qn9hcfluj">
          <div className="mx-auto w-full max-w-[1400px] px-6 pb-14 lg:px-12 lg:pb-20" data-id="element-142" data-mp="nc88cqrqrqk4">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.5,
            ease: [0.22, 1, 0.36, 1]
          }} className="max-w-xl" data-id="element-143" data-mp="neazje4mrpqf">
              <p className="eyebrow text-ink/70" data-id="element-144" data-mp="3j897lcz58bpj">Autumn / Winter 2026 — Hours of Rest</p>
              <h1 className="mt-5 font-display text-5xl font-light leading-[1.05] text-ink sm:text-6xl lg:text-7xl" data-id="element-145" data-mp="3o85ata00nz41">
                Clothing for the
                <br data-id="element-146" data-mp="39a32ynlycrgz" />
                <em className="italic" data-id="element-147" data-mp="3e9frdcsh26lo">quietest</em> hours.
              </h1>
              <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-ink/75" data-id="element-148" data-mp="3e7l8s54oaqkr">
                Night suits and t-shirts knitted from pure modal fibre, cut for women and men.
                Three colours. Made in India, in small runs.
              </p>
              <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-149" data-mp="2qkwiav1llpsj">
                <a href="#collection" className="eyebrow border border-ink bg-ink px-8 py-4 text-bone transition-colors hover:bg-transparent hover:text-ink" data-id="element-150" data-mp="2viojkfo4uo9e">
                  Shop the collection
                </a>
                <a href="#materials" className="eyebrow border border-ink/25 px-8 py-4 text-ink transition-colors hover:border-ink" data-id="element-151" data-mp="2lmv4aoj14gnx">
                  Our materials
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}